(function(angular, module) {var PillSelectController, pillSelectDirective,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

PillSelectController = (function() {

  /* @ngInject */
  function PillSelectController($element, $scope, Page) {
    this.render = bind(this.render, this);
    this.ngModel = $element.controller('ngModel');
    this.ngModel.$render = this.render;
    this.mobile = Page.isMobile();
    $scope.$on('resize', (function(_this) {
      return function() {
        return _this.mobile = Page.isMobile();
      };
    })(this));
  }

  PillSelectController.prototype.render = function() {
    this.selected = this.ngModel.$viewValue;
  };

  PillSelectController.prototype.select = function(option) {
    this.ngModel.$setViewValue(option);
    this.render();
  };

  return PillSelectController;

})();

pillSelectDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'util/widgets/pillSelect',
    scope: {
      options: '=',
      counts: '='
    },
    require: 'ngModel',
    controller: PillSelectController,
    controllerAs: 'ctrl',
    bindToController: true
  };
};

module.directive('pillSelect', pillSelectDirective);
})(angular, angular.module("dyb.util.widgets"));